export const CourseColumns = [
  {
    Header: 'Course Key',
    accessor: 'courseKey',
  },
  {
    Header: 'Status',
    accessor: 'status',
  },
  {
    Header: 'Created At',
    accessor: 'created',
  },
  {
    Header: 'Last Update',
    accessor: 'update',
  },
  {
    Header: 'Couse ID',
    accessor: 'courseID',
  },
  {
    Header: 'Is Active',
    accessor: 'isActive',
  },
  {
    Header: 'Mode/Track',
    accessor: 'mode',
  },
];

export const EnrollmentColumns = [
  {
    Header: 'Status',
    accessor: 'status',
  },
  {
    Header: 'Created At',
    accessor: 'createdAt',
  },
  {
    Header: 'Last Update',
    accessor: 'lastUpdate',
  },
  {
    Header: 'External User key',
    accessor: 'externalUserKey',
  },
];
